import type { DiagnosticRule } from '@/versions/v1/schema/diagnostic-rule';
import { ADVISORY_RULES } from '@/versions/v1/shared/bunker-hill-advisory-seed';
import { MET_DIAGNOSTICS_SECTION_RULES } from '@/versions/v1/shared/bunker-hill-met-diagnostics-rules';
import { DIAGNOSTIC_RULES } from '@/versions/v1/shared/bunker-hill-seed';

/** Join Module 1 + Module 3 + register section rule rows for lookups. */
export function allRules(): readonly DiagnosticRule[] {
  const byId = new Map<string, DiagnosticRule>();
  for (const rule of DIAGNOSTIC_RULES) {
    byId.set(rule.id, rule);
  }
  for (const rule of ADVISORY_RULES) {
    byId.set(rule.id, rule);
  }
  for (const rule of MET_DIAGNOSTICS_SECTION_RULES) {
    byId.set(rule.id, rule);
  }
  return [...byId.values()];
}

export function ruleById(ruleId: string): DiagnosticRule | undefined {
  return allRules().find((row) => row.id === ruleId);
}
